import React, { useEffect, useState } from "react";
import IntlMessages from "@util/IntlMessages";
import { Select } from "antd";
import "../list.less";

const { Option } = Select;

const ListProfileSelector = ({ profiles, setProfile, selectedProfile, currentListId }) => {
   const [defaultProfileId, setDefaultProfileId] = useState();
   const getProfileById = (id) => {
      return profiles.find((profile) => profile.id === id);
   };

   const getDefaultProfileId = () => {
      let defaultValue = null;
      if (selectedProfile.selectedProfile && currentListId === selectedProfile.profiledListId) {
         defaultValue = selectedProfile.selectedProfile.id;
      } else if (profiles?.length > 0) {
         defaultValue = profiles[0].id;
      }
      return defaultValue;
   };

   useEffect(() => {
      setDefaultProfileId(getDefaultProfileId());
   }, [currentListId, profiles]);

   return (
      <div className="list-profiles-selector">
         {profiles?.length > 0 && (
            <Select
               value={defaultProfileId}
               onSelect={(value) => {
                  const selectedProfile = getProfileById(value);
                  setProfile(selectedProfile);
               }}
            >
               {profiles.map((profile) => {
                  return (
                     <Option value={profile.id}>
                        {/* TODO - profile translations on backend */}
                        {profile.name === "All" ? (
                           <IntlMessages id="listProfiles.all" />
                        ) : (
                           profile.name
                        )}
                     </Option>
                  );
               })}
            </Select>
         )}
      </div>
   );
};

export default ListProfileSelector;
